<template>
    <tailwind-layout title="Email Preferences">
        <template #header>

            <div class="flex justify-between">
                <h2>Email Preferences</h2>
            </div>

        </template>
        <div class="bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg p-6">
            <div class="rounded-md">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="grid grid-cols-12">
                                <div class="col-span-5">
                                    <form @submit.prevent="submit">
                                        <div class="space-y-5 pl-3 mt-8">
                                            <div class="relative flex items-start">
                                                <div class="flex h-6 items-center">
                                                    <input id="newsletter_and_updates"
                                                           v-model="form.newsletter_and_updates" type="checkbox"
                                                           class="h-4 w-4 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-indigo-600"/>
                                                </div>
                                                <div class="ml-3 text-sm leading-6">
                                                    <label for="newsletter_and_updates"
                                                           class="font-medium text-gray-900">Newsletter &
                                                        Updates</label>
                                                    <p class="text-gray-500">Stay informed about the latest news,
                                                        updates, and feature releases from RentRisk.</p>
                                                </div>
                                            </div>
                                            <div class="relative flex items-start">
                                                <div class="flex h-6 items-center">
                                                    <input id="account_announcements_and_activity"
                                                           v-model="form.account_announcements_and_activity"
                                                           type="checkbox"
                                                           class="h-4 w-4 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-indigo-600"/>
                                                </div>
                                                <div class="ml-3 text-sm leading-6">
                                                    <label for="account_announcements_and_activity"
                                                           class="font-medium text-gray-900">Account Announcements &
                                                        Activity</label>
                                                    <p class="text-gray-500">Receive important notifications about your
                                                        account status, activity, and reminders to complete tasks.</p>
                                                </div>
                                            </div>
                                            <div class="relative flex items-start">
                                                <div class="flex h-6 items-center">
                                                    <input id="transactional_emails" v-model="form.transactional_emails"
                                                           type="checkbox"
                                                           class="h-4 w-4 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-indigo-600"/>
                                                </div>
                                                <div class="ml-3 text-sm leading-6">
                                                    <label for="transactional_emails" class="font-medium text-gray-900">Transactional
                                                        Emails</label>
                                                    <p class="text-gray-500">Get updates on your transactions, sign-ups,
                                                        and related activities.</p>
                                                </div>
                                            </div>
                                            <div class="relative flex items-start">
                                                <div class="flex h-6 items-center">
                                                    <input id="feedback_and_reviews" v-model="form.feedback_and_reviews"
                                                           type="checkbox"
                                                           class="h-4 w-4 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-indigo-600"/>
                                                </div>
                                                <div class="ml-3 text-sm leading-6">
                                                    <label for="feedback_and_reviews" class="font-medium text-gray-900">Feedback
                                                        & Reviews</label>
                                                    <p class="text-gray-500">Help us improve by sharing your feedback
                                                        and reviews.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <form-button :form="form"
                                                     type="submit" class="mt-12 w-full">
                                            Update Preferences
                                        </form-button>
                                    </form>
                                </div>
                                <div class="col-span-1"></div>
                                <div class="col-span-6 bg-gray-50 p-6 rounded-lg shadow-md m-8">
                                    <h2 class="text-lg font-semibold text-gray-800 mb-4">Stay in Control of Your
                                        Inbox!</h2>
                                    <p class="text-gray-600 mb-4">At <span class="font-bold">RentRisk</span>, we believe
                                        in keeping you informed without overwhelming you. Customize your email
                                        preferences to receive only the updates and notifications that matter most to
                                        you.</p>
                                    <p class="text-gray-600 mb-4">Whether you’re looking for the latest feature updates,
                                        reminders about your account, or feedback requests, you’re in charge of what you
                                        see in your inbox.</p>
                                    <p class="text-gray-600 mb-4">Take a moment to update your preferences and get the
                                        information you need, when you need it.</p>
                                    <p class="text-gray-600 font-bold">Your inbox, your rules.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script setup>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import {useForm} from "@inertiajs/vue3";

const props = defineProps({
    user_email_preference: Object,
})
const form = useForm({
    newsletter_and_updates: props.user_email_preference.newsletter_and_updates,
    account_announcements_and_activity: props.user_email_preference.account_announcements_and_activity,
    transactional_emails: props.user_email_preference.transactional_emails,
    feedback_and_reviews: props.user_email_preference.feedback_and_reviews,
})

function submit() {
    form.post(route('email-preferences.update'));
}
</script>
